import React from 'react';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

// Snackbar générique pour les retours utilisateur (succès / erreur / avertissement / info)
export default function NotificationSnackbar({ open, message, severity, onClose }) {
    return (
        <Snackbar open={open} autoHideDuration={5000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={onClose} severity={severity} variant="filled" elevation={6} style={{ borderRadius: 8 }}>
                {message}
            </Alert>
        </Snackbar>
    );
}
